// src/Home.tsx
import React from "react";
import { Route, Routes } from 'react-router-dom';
import { Auth, getAuth, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import DetailPage from '../../pages/detail';
import ClientPage from '../../pages/clients/ClientPage';
import NavBar from '../../components/navbar/NavBar';
import ProductPage from '../../pages/products/ProductPage';
import OpportunityFlow from '../../pages/configurations/flow/OpportunityFlow';
import ActivityType from '../../pages/configurations/activities/type/ActivityType';
import ActivityBranch from '../../pages/configurations/activities/branch/ActivityBranch';
import Source from '../../pages/configurations/source/Source';
import LeadPage from '../../pages/leads/LeadPage';
import DashboardPage from '../../pages/dashboard/dashboard';
import { Toaster } from '../../components/shadcn/ui/toaster';
import Levantamento from "../detail/levantamento";
import CRMDashboard from "../chartdashboard/chartdashboard";
import pkg from '../../../package.json';
import UserPage from "../users/users";
import SellersPage from "../sellers/SellersPage";

interface HomeProps {
  auth: Auth;
}
const Home: React.FC<HomeProps> = () => {
  const appVersion = pkg.version;
  const navigate = useNavigate();
  const auth = getAuth();
  const handleSignOut = async () => {
    await signOut(auth);
    navigate("/signin");
  };

  return (
    <div>
      <NavBar />
    <div className="pt-[100px] bg-indigo-200">
      <Routes>
        <Route path='/' element={<CRMDashboard />} />
        <Route path='/fluxo' element={<OpportunityFlow />} />
        <Route path='/clientes' element={<ClientPage />} />
        <Route path='/ramoatividade' element={<ActivityBranch />} />
        <Route path='/produtos' element={<ProductPage />} />
        <Route path='/fonte' element={<Source />} />
        <Route path='/detalhe/:leadId' element={<DetailPage />} />
        <Route path='/tipoatividade' element={<ActivityType />} />
        <Route path='/negocios' element={<LeadPage />} />
        <Route path='/sellers' element={<SellersPage />} />
        <Route path="/levantamento/:leadId" element={<Levantamento />}  />
        <Route path='/kanban' element={<DashboardPage />} />
        <Route path='/users' element ={<UserPage />} />
      </Routes>
    </div>
    <Toaster />
    </div>
  );
};

export default Home;
